define([
    "jquery",
    "underscore",
    "backbone",
    "models/spread_swap_quote_model",
    "templates/trading/quote_list_item.html"
], function ($, _, Backbone, SpreadSwapQuote, quoteListTemplate) {
    return Backbone.View.extend({
        el: '#content_layout',

        events: {
            'click #view_all_button': function (e) {
                this.viewAll = !(this.viewAll);
                this.getQuotes();
                if (this.viewAll) {
                    $('#view_all_button .collapse_txt').show();
                    $('#view_all_button .view_all_txt').hide();
                } else {
                    $('#view_all_button .collapse_txt').hide();
                    $('#view_all_button .view_all_txt').show();
                    location.href = "#top_quote";
                }
            },
            'click .member_type': function (e) {
                if (e) e.preventDefault();

                var type = $(e.currentTarget).data('type');

                if (type) {
                    this.$el.find('.ct_listgchild').removeClass('active');
                    $(e.currentTarget).addClass('active');

                    this.$el.find('.security_type').removeClass('active');
                    this.$el.find('.swap-sub-tabs li:first-child a').addClass('active');

                    this.memberType = type;
                    this.securityType = 'forex';
                    this.setQuoteTab();
                    this.getQuotes();
                }
            },

            'click .security_type': function (e) {
                if (e) e.preventDefault();

                var type = $(e.currentTarget).data('type');
                if (type) {
                    this.$el.find('.security_type').removeClass('active');
                    $(e.currentTarget).addClass('active');

                    this.securityType = type;
                    this.getQuotes();
                }
            },
        },

        initialize: function () {
            this.securityType = 'forex';
            this.memberType = window.activeMemberType;
            this.viewAll = false;
            this.setQuoteTab();
            this.getQuotes();
            this.setTimer();
            this.titleBid = $('.quote-title-bid')[0].innerText;
            this.titleAsk = $('.quote-title-ask')[0].innerText;
            this.collapsedRowMaps = {
                'forex': 7,
                'metal': 3,
                'commodity': 2,
                'index': 3,
            }
        },

        setQuoteTab: function () {
            if (this.memberType === 'most_popular') {
                $('#quote_tab_forex').hide();
                $('#quote_tab_metal').hide();
                $('#quote_tab_commodity').hide();
                $('#quote_tab_index').hide();
                $('#quote_tab_stock').hide();
                $('#view_all_button').hide();
            } else if (this.memberType === 'ecn') {
                $('#quote_tab_forex').show();
                $('#quote_tab_metal').show();
                $('#quote_tab_commodity').hide();
                $('#quote_tab_index').hide();
                $('#quote_tab_stock').hide();
                $('#view_all_button').show();
            } else if (this.memberType === 'cent') {
                $('#quote_tab_forex').show();
                $('#quote_tab_metal').show();
                $('#quote_tab_commodity').hide();
                $('#quote_tab_index').hide();
                $('#quote_tab_stock').hide();
                $('#view_all_button').show();
            }else if (this.memberType === 'pro') {
                $('#quote_tab_forex').show();
                $('#quote_tab_metal').show();
                $('#quote_tab_commodity').show();
                $('#quote_tab_index').show();
                $('#quote_tab_stock').show();
                $('#view_all_button').hide();
            } else if (this.memberType === 'standard') {
                $('#quote_tab_forex').show();
                $('#quote_tab_metal').show();
                $('#quote_tab_commodity').show();
                $('#quote_tab_index').show();
                $('#quote_tab_stock').show();
                $('#view_all_button').show();
            } else {
                $('#quote_tab_forex').show();
                $('#quote_tab_metal').show();
                $('#quote_tab_commodity').show();
                $('#quote_tab_index').show();
                $('#quote_tab_stock').hide();
                $('#view_all_button').show();
            }
        },

        // Recursively calling the set timeout makes sure that we don't have two of them running at the same time.
        setTimer: function () {
            var that = this;
            setTimeout(function () {
                $.when(
                    that.getQuotes()
                ).done(function () {
                    that.setTimer();
                });
            }, 1500);
        },

        getQuotes: function () {
            var that = this;
            var quote = new SpreadSwapQuote();

            var data = {
                'member_type': this.memberType,
                'need_to_sort': false,
                't': $.now()
            };
            if (this.memberType !== 'most_popular') {
                data['security'] = this.securityType;
            }

            // Return the fetch promise
            return quote.fetch({
                data: data,
                success: function (model, response, options) {
                    that.$('#quote_list').html('');
                    var i = 0;
                    var rowNums = 10;
                    if (that.securityType) rowNums = that.collapsedRowMaps[that.securityType];
                    _.each(model.get('quotes'), function (element, key, list) {
                        if (!that.viewAll && i > rowNums) return false;
                        element.titleBid = that.titleBid;
                        element.titleAsk = that.titleAsk;
                        element['boldRowNum'] = rowNums;
                        element['currentRowNum'] = i++;
                        element['hotBadgePath'] = window.hotBadgePath;
                        that.$('#quote_list').append(quoteListTemplate({quote: element}));
                    });
                },
                error: function (model, response, options) {
                }
            });
        },
    });
});
